import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_ALL_PROS } from '@core/ui/graphql/AllPros.query';
import { useTranslation } from 'next-i18next';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';
import Link from 'next/link';
import styled from 'styled-components';
import {
  Image,
  ImageWrapper,
} from '../../components/UserInfoBox/userInfoBox.style';
import { slugify } from '../../helpers/urlHandler';

const List = styled('div')`
  li {
    list-style-type: none;

    margin-bottom: 20px;
    width: 280px;
  }
  li ul {
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 0;
  }
  li ul li {
    margin-bottom: 5px;
    margin-top: 5px;
  }
`;

const Pros = () => {
  const { t } = useTranslation();

  const { data = {} } = useQuery(GET_ALL_PROS);

  const { pros: { data: pros = [] } = {} } = data || {};

  const getPros = () => {
    let prosSorted = [...pros];

    if (prosSorted.length > 0) {
      prosSorted.sort((a, b) => a.alternateName.localeCompare(b.alternateName));
    }

    return (
      <ul
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 50,
        }}
      >
        {prosSorted.map(pro => {
          return (
            <li key={pro.id}>
              <Link
                href={
                  '/pro/' + slugify(pro.alternateName) + '-' + slugify(pro.sid)
                }
              >
                <a
                  style={{
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    color: '#155876',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                >
                  {pro.imageProfil && (
                    <ImageWrapper
                      imgWidth={112}
                      imgHeight={112}
                      imgRadius={85}
                      style={{
                        marginBottom: 10,
                        boxShadow: '2px 2px 2px #f1f1f1',
                      }}
                    >
                      <Image
                        src={pro.imageProfil}
                        alt="image"
                        width="112px"
                        height="112px"
                      />
                    </ImageWrapper>
                  )}
                  <h3>{pro.alternateName}</h3>
                </a>
              </Link>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <Grid
      style={{
        paddingTop: 35,
        backgroundColor: 'white',
        padding: '40px 12px',
        fontFamily: 'Poppins',
        minHeight: '50vw',
      }}
    >
      <Row>
        <Col style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
          <h2>{t('pros.body.title')}</h2>
        </Col>
      </Row>
      <Row>
        <Col style={{ width: '100%' }}>
          <List>{getPros()}</List>
        </Col>
      </Row>
    </Grid>
  );
};

export default Pros;
